import Hotels24Tab from './Hotels24Tab'

export default Hotels24Tab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/index.js